import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { INSAutoCompleteGroup } from '@norfolk-southern/accessns-components';
import { INSAutoCompleteOption } from '@norfolk-southern/accessns-components/lib/autocomplete/models/autocomplete.interface';
import { Observable } from 'rxjs';

import { IUserInfo } from '@ruby/modules/account/models/contact.interface';
import { DiversionsCoreActions, DiversionsCoreSelectors, fromDiversionsCore } from '@ruby/modules/diversions/store/diversions-core.index';
import { IDiversionsWaybillDetail } from '@ruby/shared/models/diversions/diversions.interface';
import { IError } from '@ruby/shared/models/request/error.interface';

@Component({
  selector: 'ng-diversions-complete-container',
  templateUrl: './diversions-complete.container.html'
})
export class DiversionsCompleteContainer {
  store$: Observable<{
    isLoadingRoads: boolean;
    isLoadingStates: boolean;
    isLoadingComplete: boolean;
    error?: IError;
    states: Array<INSAutoCompleteGroup>;
    roads: Array<INSAutoCompleteOption>;
    internalRole?: boolean;
    userInfo?: IUserInfo;
    waybillDetail?: IDiversionsWaybillDetail;
  }>;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { customerNumber: string; customerSequence: string }, private store: Store<fromDiversionsCore.State>) {
    this.store$ = this.store.select(DiversionsCoreSelectors.selectWaybillDetailState);
  }

  /**
   * Complete
   *
   * @summary Complete pending request of any diversion type
   * @params $reason: string
   * @returns void
   */
  complete($reason: string): void {
    this.store.dispatch(DiversionsCoreActions.complete({
      data: {
        reason: $reason,
        customerNumber: this.data.customerNumber,
        customerSequence: this.data.customerSequence
      }
    }));
  }
}
